function csvToJson(csv) {
  const lines = csv.split("\n");
  const result = [];
  let headers = lines[0].split(",");

  headers = headers.map(o => o.trim());

  for (let i = 1; i < lines.length; i++) {
    const obj = {};
    const currentline = lines[i].split(",");
    for (let j = 0; j < headers.length; j++) {
      obj[headers[j]] = currentline[j];
    }
    result.push(obj);
  }

  return result;
}

export function base64ToBlob(base64Data, contentType = "application/pdf") {
  const base64WithoutPrefix = base64Data?.includes(",")
    ? base64Data.split(",")[1]
    : base64Data;

  const byteCharacters = atob(base64WithoutPrefix);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += 512) {
    const slice = byteCharacters.slice(offset, offset + 512);
    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    byteArrays.push(new Uint8Array(byteNumbers));
  }

  return new Blob(byteArrays, { type: contentType });
}

export default {
  csvToJson,
  base64ToBlob,
};
